import { BaseRouteService } from 'core/services';

class LookupRouteService extends BaseRouteService {
	constructor(lookupRoute) {
		super();
		this.base = lookupRoute;
	}

	find(filter) {
		return super.find(
			this.base + '{?searchQuery,page,rpp,sort,embed,fields,ids,showUserFilter,bulkPrintMode,ignoreSystemValues}',
			filter
		);
	}

	get(id, options) {
		return super.get(this.base + '/{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', {
			sourceOfChange,
		});
	}

	createBatch(sourceOfChange) {
		return super.create(this.base + '/batch/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '/{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '/{id}', resource);
	}
}

export default LookupRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/LookupRouteService.js